module.exports = __webpack_public_path__ + "static/FaktSoftPro-Blond.6cfc3d88.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FaktSoftPro-Blond.woff2
// module id = 490
// module chunks = 114276838955818